import {
    createStaticPage,
    getContenfulStaticProps,
} from '@lib/static/static-page'
import { PAGE_OPTIONS } from '@lib/utils/page'

export const getStaticProps = getContenfulStaticProps(
    PAGE_OPTIONS.DIRECT_DEPOSIT.slug,
)
export default createStaticPage(PAGE_OPTIONS.DIRECT_DEPOSIT)
